import React, {Component, useEffect, useState} from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { config } from "../../data";
import * as api from "../../api";
import { setPreloader } from "../../redux/actions";

import {
  counterEffect,
  getImageAverageColor,
  redirect,
  splitThousands,
} from "../../helpers";
import { togglePopup } from "../../containers";
import { QuestSwitcher } from "../quest-switcher";
import { Hero } from "../hero";
import LinkButton from "../link-button/link-button";
import Button from "../button/button";
import { MapPromo } from "../../containers/map-promo/map-promo";
import * as auth from "../../helpers/authenticationHelper";
import { CabinetMenu } from "../cabinet-menu";
import s from './mapnav.module.css';
import style from "../../containers/banners/sale/sale.module.sass";

class MapNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clientIsSubscription: ["on", "soon_finished"].includes(
        (auth.getProfile() || {}).subscription?.status || {
          recurrent_status: 2,
        }
      ),
      openPromoWindow: auth.getProfile() && auth.getProfile().subscription && auth.getProfile().subscription.status !== 'off',
      childPointsId: 0,
      points: 0,
      prev_points: -1,
      updatePoints: false,
      balance: 0,
      prev_balance: -1,
      updateBalance: false,
      showMenu: false,
      zoomQuest: false,
      avatarSticker: 1,
      percentToNextLevel: 0,
      coins: 0,
      showPopup: false,
      currentQuest: null,
      settingsShow: false,
      rateShow: false,
      gamesShow: false,
      avatarAverageColor: "#FFFFFF",
    };
  }

  counterRef = React.createRef();
  userAvatarRef = React.createRef();

  actualizeInfo = (zoom) => {
    const { user, forceUpdate } = this.props;
    if (!user) return;

    api.getChild(user.currentChildId).then((data) => {
      let {
        prev_balance,
        prev_points,
        updatePoints,
        updateBalance,
        childPointsId,
      } = this.state;
      let child = user.children?.find((c) => c.id === user.currentChildId);

      let newState = {
        percentToNextLevel: data.percent_to_next_level,
        balance: data.balance,
        points: data.points,
        childPointsId: child.id,
        avatarSticker: data.has_new_skin ? 1 : 0,
        coins: this.formatCoins(data.balance),
      };

      if (
        !updateBalance &&
        (forceUpdate < 0 ||
          (prev_balance >= 0 && prev_balance !== data.balance))
      ) {
        if (data.id === child.id) {
          newState.updateBalance = true;
        }

        if (forceUpdate < 0) {
          newState.prev_balance = 0;
        }
      } else {
        newState.prev_balance = data.balance;
        newState.balance = data.balance;
      }

      if (!updatePoints && prev_points >= 0 && prev_points !== data.points) {
        if (!childPointsId || childPointsId === child.id) {
          newState.updatePoints = true;
        }
      } else {
        newState.prev_points = data.points;
        newState.points = data.points;
      }

      this.setState(newState, () => {
        if (zoom !== void 0) {
          this.setState({ zoomQuest: zoom });
        }
      });

      this.setBackgroundColor();
    });
  };

  componentDidMount() {
    this.actualizeInfo(true);

    window.updateProfile = () => {
      this.actualizeInfo(true);
    };
  }

  componentWillUnmount() {
    window.updateProfile = null;
  }

  componentDidUpdate(prevProps, prevState) {
    const { user } = this.props;

    // if (this.props.user && this.props.user.currentChildId !== prevProps.user.currentChildId) {
    //   this.setBackgroundColor();
    // }

    if (prevProps.forceUpdate !== this.props.forceUpdate) {
      this.actualizeInfo(void 0);
      return;
    }

    if (
      !user ||
      JSON.stringify(prevProps.user) === JSON.stringify(user) ||
      prevProps.quests
    )
      return;

    this.actualizeInfo(void 0);
  }

  formatCoins(coins = 0) {
    const coinsString = `${coins}`;
    return splitThousands(coinsString);
  }

  setBackgroundColor() {
    getImageAverageColor(this.userAvatarRef.current).then((color) => {
      this.setState({ avatarAverageColor: color });
    });
  }

  render() {
    const {
      percentToNextLevel,
      balance,
      updateBalance,
      prev_balance,
      updatePoints,
    } = this.state;
    const {
      user,
      quests,
      children,
      activeQuestID,
      onQuestChange,
      opacity,
      lessonsScreenType,
    } = this.props;
    const { routes } = config;
    let avatar = "";

    if (user) {
      let child = user.children?.find((c) => c.id === user.currentChildId);
      avatar = child?.avatar
        ? `${config.base_url}/${child.avatar}`
        : "/img/avatars/default_avatar.png";
    }

    const regDate = new Date(auth.getProfile()?.created_at);
    const nowDate = new Date();




    let userSubscription = auth.getProfile() && auth.getProfile().subscription && auth.getProfile().subscription.status !== 'off';

    const createdDays =
      (nowDate.getTime() - regDate.getTime()) / (1000 * 60 * 60 * 24);

console.log(userSubscription);


    return (
      <div className="map-nav">
        {user && (
          <div className="map-nav__header">
            {(!this.state.openPromoWindow && lessonsScreenType === "default" && !this.state.className) && (
              <div  className={s.black_friday_promo}>
                <div className={s.black_friday_title}>ЖДЕМ<br/>НОВЫЙ ГОД</div>
                <div className={s.sale}>Скидка 70%</div>
                <div className={s.desc}>Безлимитный доступ ко всем курсам на 12 месяцев</div>
                <img onClick={()=>{
                  this.setState({ openPromoWindow: true });
                }} className={s.close_icon} src={'/img/close.png'} alt="close" />
                <Link
                  to="/cabinet/select_tariff/"
                  className={s.button}
                  style={{placeItems: 'center', textDecoration: 'none'}}
                  type="button"
                >
                  <img className={s.ninja_image} src={'img/CHE_elf1.png'} alt="aa"/>
                  Оформить
                </Link>

              </div>
            )}
            {createdDays < 3 &&
              lessonsScreenType !== "cabinet" &&
                  lessonsScreenType !== "quest" &&
                  !this.state.className && <MapPromo/>}
                {lessonsScreenType === "default" && (
                  <div>
                    <LinkButton
                      mod={"adaptive_quest_button"}
                      to={routes.quests}
                      color="navy-blue"
                    >
                      <svg
                        width="40"
                        height="40"
                        viewBox="0 0 40 40"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.59998 19.96C8.79998 13.1588 14 11.9588 20 19.96C26.3892 28.4803 31.2 27.1588 34.4 19.96"
                          stroke="white"
                          strokeWidth="2.2"
                          strokeLinecap="round"
                          strokeDasharray="4 5"
                        />
                        <circle
                          cx="5.60002"
                          cy="20.1868"
                          r="2.7"
                          fill="white"
                          stroke="white"
                        />
                        <circle
                          cx="34.4001"
                          cy="20.1868"
                          r="2.7"
                          fill="white"
                          stroke="white"
                        />
                        <circle
                          cx="20"
                          cy="20.1868"
                          r="2.7"
                          fill="white"
                          stroke="white"
                        />
                      </svg>
                      <div className={"adaptive_text_button"}>
                    <span
                      style={{
                        position: "absolute",
                        color: "black",
                        backgroundColor: "white",
                        padding: "2px",
                        left: "-7px",
                        top: "55px",
                        border: "3px solid black",
                        borderRadius: "10px",
                      }}
                    >
                      Маршруты
                    </span>
                      </div>
                    </LinkButton>
                  </div>
                )}
                <div
                  className={
                    "map-nav__avatar hint_wrapper" +
                    (opacity ? " _opacity" : "") +
                    (updatePoints ? " _update" : "")
                  }
                >
                  <div
                    onClick={() => {
                      togglePopup("successReg", false);
                      setTimeout(() => {
                        redirect("/?popup=infantCabinet");

                        togglePopup("infantCabinet", true);
                      }, 1);
                    }}
                    className="map-nav__user"
                  >
                    <div className="hint_3-animation">
                      {updatePoints ? (
                        <Hero
                          width={260}
                          height={260}
                          animationStart={() => {
                            setTimeout(() => {
                              window.devMode && console.log("anim star done");
                            }, 300);
                          }}
                          animationEnd={() => {
                            setTimeout(() => {
                              this.setState({
                                updatePoints: false,
                                prev_points: this.state.points,
                              });
                            }, 100);
                          }}
                          animate={true}
                          noPreloader={true}
                          cssClass={"star_anim"}
                          name={"star_anim"}
                          text={""}
                        />
                      ) : null}
                    </div>
                    <div className="user-avatar">
                      <img
                        ref={this.userAvatarRef}
                        className="user-avatar__image"
                        src={avatar}
                        alt=""
                      />
                      <svg viewBox="0 0 110 110" className="user-avatar__progress">
                        <circle r="54" cx="55" cy="55" fill="#FFFFFF"/>
                        <circle
                          r="43"
                          cx="55"
                          cy="55"
                          fill={this.state.avatarAverageColor}
                          opacity="0.3"
                          className="user-avatar__bg"
                        />
                        <circle
                          r="49"
                          cx="55"
                          cy="55"
                          fill="none"
                          strokeWidth="12"
                          stroke={this.state.avatarAverageColor}
                          opacity="0.6"
                          className="user-avatar__border"
                        />
                        <circle
                          r="49"
                          cx="55"
                          cy="55"
                          fill="none"
                          strokeWidth="12"
                          stroke={this.state.avatarAverageColor}
                          className="user-avatar__progress-line"
                          strokeLinecap="round"
                          strokeDasharray="295"
                          strokeDashoffset={295 - (percentToNextLevel / 100) * 295}
                        />
                      </svg>
                    </div>
                  </div>

                  {lessonsScreenType !== "cabinet" && (
                    <span
                      className="map-nav__name"
                      onClick={() => {
                        togglePopup("successReg", false);
                        setTimeout(() => {
                          togglePopup("infantCabinet", true);
                        }, 1);
                      }}
                    >
                  {user.currentChildName}
                </span>
                  )}
                </div>

                {lessonsScreenType === "successReg" && (
                  <span
                    className={"map-nav__btn map-nav__quest hint_wrapper _zoom"}
                  >
                <div className="hint"/>
                <Link
                  className="map-nav__btn map-nav__quest new-button new-button_color_navy-blue new-button_size_m"
                  to={"/" + routes.quests}
                >
                  <svg
                    width="40"
                    height="40"
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.59998 19.96C8.79998 13.1588 14 11.9588 20 19.96C26.3892 28.4803 31.2 27.1588 34.4 19.96"
                      stroke="white"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeDasharray="4 5"
                    />
                    <circle
                      cx="5.60002"
                      cy="20.1868"
                      r="2.7"
                      fill="white"
                      stroke="white"
                    />
                    <circle
                      cx="34.4001"
                      cy="20.1868"
                      r="2.7"
                      fill="white"
                      stroke="white"
                    />
                    <circle
                      cx="20"
                      cy="20.1868"
                      r="2.7"
                      fill="white"
                      stroke="white"
                    />
                  </svg>
                </Link>
              </span>
                )}

                {lessonsScreenType === "quest" &&
                  (activeQuestID !== null && +activeQuestID >= 0 ? (
                    <div className="map-nav__title">
                      <QuestSwitcher
                        quests={quests}
                        activeQuestID={+activeQuestID}
                        onChange={onQuestChange}
                      />
                    </div>
                  ) : (
                    <div className="map-nav__title">Маршруты</div>
                  ))}

                {lessonsScreenType === "coinShop" && (
                  <div className="map-nav__title">Магазин</div>
                )}

                {lessonsScreenType !== "quest" && (
                  <Button
                    mod={
                      "map-nav__shop hint_wrapper" +
                      (this.state.prev_balance > this.state.balance
                        ? " _reverse"
                        : "") +
                      (opacity ? " _opacity" : "") +
                      (updateBalance ? " _update" : "")
                    }
                    onClick={() => {
                      togglePopup("coinShop", true);
                    }}
                    color="white"
                  >
                    <div className={"map-nav__shop-item"}>
                      <div className="hint_2-animation">
                        {updateBalance || true ? (
                          <Hero
                            width={260}
                            height={260}
                            animationStart={() => {
                              setTimeout(() => {
                                counterEffect(
                                  this.counterRef.current,
                                  this.state.prev_balance,
                                  this.state.balance,
                                  13,
                                  3000
                                );
                              }, 300);
                            }}
                            animationEnd={() => {
                              setTimeout(() => {
                                this.setState({
                                  updateBalance: false,
                                  prev_balance: this.state.balance,
                                });
                              }, 100);
                            }}
                            animate={true}
                            noPreloader={true}
                            cssClass={"coin_anim"}
                            name={"coin_anim"}
                            text={""}
                          />
                        ) : null}
                      </div>
                      <span className="map-nav__shop-icon"/>
                    </div>
                    <div ref={this.counterRef} className="map-nav__shop-item">
                      {updateBalance
                        ? this.formatCoins(prev_balance)
                        : this.formatCoins(balance)}
                    </div>
                    <div className="map-nav__shop-item">
                      <Button color="green" customTag="span">
                        <svg
                          width="40"
                          height="40"
                          viewBox="0 0 40 40"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M21.4707 11.6179C21.4707 10.6811 20.7113 9.92168 19.7745 9.92168V9.92168C18.8377 9.92168 18.0783 10.6811 18.0783 11.6179L18.0783 28.3822C18.0783 29.3189 18.8377 30.0783 19.7745 30.0783V30.0783C20.7113 30.0783 21.4707 29.3189 21.4707 28.3822L21.4707 11.6179Z"
                            fill="white"
                          />
                          <path
                            d="M28.157 21.6959C29.0938 21.6959 29.8532 20.9364 29.8532 19.9997V19.9997C29.8532 19.0629 29.0938 18.3035 28.157 18.3035H11.3927C10.4559 18.3035 9.6965 19.0629 9.6965 19.9997V19.9997C9.6965 20.9364 10.4559 21.6959 11.3927 21.6959L28.157 21.6959Z"
                            fill="white"
                          />
                        </svg>
                      </Button>
                    </div>
                  </Button>
                )}
              </div>
            )}
            <div></div>
            {this.state.showMenu && (
          <div
            className={"adaptive_setting_menu__wrapper"}
            onClick={() => {
              this.setState({ showMenu: !this.state.showMenu });
            }}
          >
            <div className={"adaptive_setting_menu"}>
              <CabinetMenu showPopUp={this.showPopUp} />
            </div>
          </div>
        )}

        {user && lessonsScreenType !== "lesson" && window.innerWidth < 901 && (
          <Button
            onClick={() => {
              this.setState({ showMenu: !this.state.showMenu });
            }}
            mod={"adaptive_settings_button"}
            color="orange"
          >
            <svg
              onPointerOver={() => {
                this.setState({ settingsShow: true });
              }}
              onPointerLeave={() => {
                this.setState({ settingsShow: false });
              }}
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.8388 12.6386C18.1313 12.6386 19.1654 11.6162 19.1654 10.3247C19.1654 9.03319 18.1313 8 16.8388 8C15.5462 8 14.5122 9.03319 14.5122 10.3247C14.5122 11.6162 15.5462 12.6386 16.8388 12.6386ZM13.1226 32C13.6289 32 13.9736 31.7202 14.1567 31.053C14.5229 29.7292 15.6108 25.2198 15.9771 24.1328C16.2248 23.3578 16.3971 23.0565 16.8388 23.0565C17.2804 23.0565 17.4527 23.3578 17.7005 24.1328C18.0667 25.2198 19.1546 29.7292 19.5209 31.053C19.704 31.7202 20.0487 32 20.5549 32C21.2443 32 21.6644 31.3758 21.4705 30.6978C21.395 30.4072 19.8332 23.8853 19.607 22.54C19.4239 21.356 19.3808 18.9668 19.3808 17.8368C19.3808 17.6646 19.5747 17.6 19.6824 17.7507L20.8996 19.4511C21.0289 18.8054 21.6321 18.1058 22.5369 18.0843L20.8673 15.652C19.9625 14.339 18.8853 13.7686 16.8388 13.7686C14.7922 13.7686 13.6935 14.3498 12.8103 15.652L10.0205 19.7525C9.91276 19.9139 9.79427 20.0753 9.7081 20.2368C9.4819 20.6458 9.60039 21.2377 10.1605 21.5283C10.5806 21.765 11.0976 21.7004 11.41 21.3345C11.7008 20.9901 13.1873 18.8915 13.9951 17.7507C14.0921 17.6108 14.2967 17.6646 14.2967 17.8476C14.2967 18.9776 14.2429 21.356 14.0597 22.54C13.8443 23.8853 12.2825 30.4072 12.2071 30.6978C12.0132 31.3758 12.4333 32 13.1226 32ZM25.8976 20.0753C26.8454 20.0753 27.6317 19.3005 27.6317 18.3534C27.6317 17.4063 26.8454 16.6314 25.8976 16.6314C24.9497 16.6314 24.1741 17.4063 24.1741 18.3534C24.1741 19.3005 24.9497 20.0753 25.8976 20.0753ZM23.5063 32C23.9156 32 24.2495 31.7633 24.3896 31.2251C24.6158 30.418 25.2728 27.6413 25.4883 26.9632C25.639 26.522 25.6713 26.4897 25.7898 26.4897C25.9083 26.4897 25.9299 26.522 26.0807 26.9632C26.2961 27.6413 26.9531 30.418 27.1901 31.2251C27.3193 31.7633 27.664 32 28.0733 32C28.6874 32 29.0428 31.4297 28.892 30.8701C28.8382 30.687 27.901 26.6942 27.7503 25.8548C27.664 25.3381 27.621 24.4341 27.621 24.0574C27.621 23.8853 27.8256 23.8314 27.9226 23.9713L29.3013 25.9623C29.5922 26.3821 30.0661 26.3929 30.3677 26.1669C30.6585 25.9731 30.7985 25.575 30.5293 25.166L28.7412 22.4108C28.1272 21.4637 27.1577 21.087 26.1668 21.087H25.7898C25.0681 21.087 24.7558 20.861 24.2711 20.3444L23.1293 19.1283C22.8384 18.8269 22.2675 18.8162 21.9444 19.1928C21.6428 19.4942 21.5566 19.9355 21.8044 20.3122C21.9228 20.4951 22.9139 21.6037 23.6894 22.5723C23.8618 22.7875 23.9587 22.9919 23.9587 23.304C23.9587 23.8422 23.9371 25.1875 23.8295 25.8548C23.6786 26.6942 22.7415 30.687 22.6768 30.8701C22.5369 31.4297 22.8924 32 23.5063 32Z"
                fill="white"
              />
            </svg>
          </Button>
        )}

        {user && lessonsScreenType !== "lesson" && (
          <div className={"map-nav__body"}>
            <LinkButton to={routes.games} mod="map-nav__btn" color="gray">
              <svg
                onPointerOver={() => {
                  this.setState({ gamesShow: true });
                }}
                onPointerLeave={() => {
                  this.setState({ gamesShow: false });
                }}
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.6485 28.1418C11.929 28.1418 12.7378 27.6925 13.5017 26.7601L15.0743 24.8505C15.2877 24.5922 15.5573 24.4574 15.8044 24.4574H24.1842C24.4426 24.4574 24.7122 24.5922 24.9256 24.8505L26.4982 26.7601C27.2508 27.6925 28.0595 28.1418 29.3402 28.1418C31.4183 28.1418 32.8 26.7714 32.8 24.6484C32.8 23.7609 32.5977 22.7275 32.2607 21.593C31.7215 19.7957 30.778 17.3357 29.8794 15.4485C29.1154 13.831 28.711 13.0671 26.8015 12.6403C25.1615 12.2696 22.87 12 19.9943 12C17.1299 12 14.8384 12.2696 13.1984 12.6403C11.2888 13.0671 10.8844 13.831 10.1093 15.4485C9.22189 17.3357 8.27831 19.7957 7.73914 21.593C7.40214 22.7275 7.19995 23.7609 7.19995 24.6484C7.19995 26.7714 8.58161 28.1418 10.6485 28.1418ZM12.8389 18.3129C12.8389 17.8074 13.1422 17.4929 13.6701 17.4929H15.0855V16.145C15.0855 15.6283 15.3776 15.3137 15.8831 15.3137C16.3773 15.3137 16.6694 15.6283 16.6694 16.145V17.4929H17.9949C18.5565 17.4929 18.8823 17.8074 18.8823 18.3129C18.8823 18.8409 18.5565 19.1554 17.9949 19.1554H16.6694V20.5034C16.6694 21.0201 16.3773 21.3346 15.8831 21.3346C15.3776 21.3346 15.0855 21.0201 15.0855 20.5034V19.1554H13.6701C13.1422 19.1554 12.8389 18.8409 12.8389 18.3129ZM24.0719 16.9313C24.0719 16.1899 24.6448 15.6058 25.3749 15.6058C26.1275 15.6058 26.6892 16.1899 26.6892 16.9313C26.6892 17.6727 26.1275 18.2455 25.3749 18.2455C24.6448 18.2455 24.0719 17.6727 24.0719 16.9313ZM21.5332 19.5261C21.5332 18.7735 22.1174 18.2006 22.8475 18.2006C23.5889 18.2006 24.1505 18.7735 24.1505 19.5261C24.1505 20.2675 23.5889 20.8291 22.8475 20.8291C22.1174 20.8291 21.5332 20.2675 21.5332 19.5261Z"
                  fill="white"
                />
              </svg>
            </LinkButton>
            {(this.state.gamesShow || lessonsScreenType === "cabinet") && (
              <span
                className={`${
                  lessonsScreenType === "cabinet"
                    ? "nav-button__name__cabinet"
                    : "nav-button__name"
                }`}
              >
                <span style={{ width: "50px" }}></span>{" "}
                {window.innerWidth > 900 && <>Игры</>}
              </span>
            )}
            {!this.state.gamesShow && lessonsScreenType !== "cabinet" && (
              <span>
                <span style={{ width: "50px" }}></span>
              </span>
            )}
            {window.innerWidth > 900 && (
              <Button
                mod="map-nav__btn"
                onClick={() => {
                  togglePopup("scoreTable", true);
                }}
                color="yellow"
              >
                <svg
                  onPointerOver={() => {
                    this.setState({ rateShow: true });
                  }}
                  onPointerLeave={() => {
                    this.setState({ rateShow: false });
                  }}
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.59998 12.2471C9.59998 16.5272 11.7144 19.2696 15.9432 20.4357C16.5071 21.0764 17.1094 21.6018 17.7116 21.9863V26.4201H16.2508C14.7258 26.4201 13.9442 27.3043 13.9442 28.7268V30.3414C13.9442 30.854 14.3542 31.2 14.8283 31.2H24.6059C25.0801 31.2 25.4901 30.854 25.4901 30.3414V28.7268C25.4901 27.3043 24.7084 26.4201 23.1835 26.4201H21.7226V21.9863C22.3249 21.6018 22.9272 21.0764 23.5039 20.4357C27.7199 19.2696 29.8343 16.5272 29.8343 12.2471C29.8343 11.1451 29.1679 10.4915 28.0274 10.4915H25.9643C25.772 9.42791 25.016 8.79999 23.7217 8.79999H15.7125C14.4183 8.79999 13.6622 9.42791 13.47 10.4915H11.4068C10.2663 10.4915 9.59998 11.1451 9.59998 12.2471ZM24.9776 18.27C25.6183 17.0398 26.0283 15.5917 26.0283 14.0284V12.2215H28.0018C28.1171 12.2215 28.2068 12.3112 28.2068 12.4265C28.2068 15.2842 27.1048 17.2577 24.9776 18.27ZM11.2274 12.4265C11.2274 12.3112 11.3171 12.2215 11.4325 12.2215H13.4059V14.0284C13.4059 15.5917 13.816 17.0398 14.4567 18.27C12.3295 17.2577 11.2274 15.2842 11.2274 12.4265Z"
                    fill="white"
                  />
                </svg>
              </Button>
            )}

            {(this.state.rateShow || lessonsScreenType === "cabinet") && (
              <span
                className={`${
                  lessonsScreenType === "cabinet"
                    ? "nav-button__name__cabinet"
                    : "nav-button__name"
                }`}
              >
                <span style={{ width: "50px" }}></span>{" "}
                {window.innerWidth > 900 && <>Рейтинг</>}
              </span>
            )}
            {!this.state.rateShow && lessonsScreenType !== "cabinet" && (
              <span>
                <span style={{ width: "50px" }}></span>
              </span>
            )}
            {window.innerWidth > 900 && (
              <LinkButton
                to={`${routes.child}/${user.currentChildId}`}
                mod="map-nav__btn"
                color="orange"
              >
                <svg
                  onPointerOver={() => {
                    this.setState({ settingsShow: true });
                  }}
                  onPointerLeave={() => {
                    this.setState({ settingsShow: false });
                  }}
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.8388 12.6386C18.1313 12.6386 19.1654 11.6162 19.1654 10.3247C19.1654 9.03319 18.1313 8 16.8388 8C15.5462 8 14.5122 9.03319 14.5122 10.3247C14.5122 11.6162 15.5462 12.6386 16.8388 12.6386ZM13.1226 32C13.6289 32 13.9736 31.7202 14.1567 31.053C14.5229 29.7292 15.6108 25.2198 15.9771 24.1328C16.2248 23.3578 16.3971 23.0565 16.8388 23.0565C17.2804 23.0565 17.4527 23.3578 17.7005 24.1328C18.0667 25.2198 19.1546 29.7292 19.5209 31.053C19.704 31.7202 20.0487 32 20.5549 32C21.2443 32 21.6644 31.3758 21.4705 30.6978C21.395 30.4072 19.8332 23.8853 19.607 22.54C19.4239 21.356 19.3808 18.9668 19.3808 17.8368C19.3808 17.6646 19.5747 17.6 19.6824 17.7507L20.8996 19.4511C21.0289 18.8054 21.6321 18.1058 22.5369 18.0843L20.8673 15.652C19.9625 14.339 18.8853 13.7686 16.8388 13.7686C14.7922 13.7686 13.6935 14.3498 12.8103 15.652L10.0205 19.7525C9.91276 19.9139 9.79427 20.0753 9.7081 20.2368C9.4819 20.6458 9.60039 21.2377 10.1605 21.5283C10.5806 21.765 11.0976 21.7004 11.41 21.3345C11.7008 20.9901 13.1873 18.8915 13.9951 17.7507C14.0921 17.6108 14.2967 17.6646 14.2967 17.8476C14.2967 18.9776 14.2429 21.356 14.0597 22.54C13.8443 23.8853 12.2825 30.4072 12.2071 30.6978C12.0132 31.3758 12.4333 32 13.1226 32ZM25.8976 20.0753C26.8454 20.0753 27.6317 19.3005 27.6317 18.3534C27.6317 17.4063 26.8454 16.6314 25.8976 16.6314C24.9497 16.6314 24.1741 17.4063 24.1741 18.3534C24.1741 19.3005 24.9497 20.0753 25.8976 20.0753ZM23.5063 32C23.9156 32 24.2495 31.7633 24.3896 31.2251C24.6158 30.418 25.2728 27.6413 25.4883 26.9632C25.639 26.522 25.6713 26.4897 25.7898 26.4897C25.9083 26.4897 25.9299 26.522 26.0807 26.9632C26.2961 27.6413 26.9531 30.418 27.1901 31.2251C27.3193 31.7633 27.664 32 28.0733 32C28.6874 32 29.0428 31.4297 28.892 30.8701C28.8382 30.687 27.901 26.6942 27.7503 25.8548C27.664 25.3381 27.621 24.4341 27.621 24.0574C27.621 23.8853 27.8256 23.8314 27.9226 23.9713L29.3013 25.9623C29.5922 26.3821 30.0661 26.3929 30.3677 26.1669C30.6585 25.9731 30.7985 25.575 30.5293 25.166L28.7412 22.4108C28.1272 21.4637 27.1577 21.087 26.1668 21.087H25.7898C25.0681 21.087 24.7558 20.861 24.2711 20.3444L23.1293 19.1283C22.8384 18.8269 22.2675 18.8162 21.9444 19.1928C21.6428 19.4942 21.5566 19.9355 21.8044 20.3122C21.9228 20.4951 22.9139 21.6037 23.6894 22.5723C23.8618 22.7875 23.9587 22.9919 23.9587 23.304C23.9587 23.8422 23.9371 25.1875 23.8295 25.8548C23.6786 26.6942 22.7415 30.687 22.6768 30.8701C22.5369 31.4297 22.8924 32 23.5063 32Z"
                    fill="white"
                  />
                </svg>
              </LinkButton>
            )}
            {(this.state.settingsShow || lessonsScreenType === "cabinet") && (
              <span
                className={`${
                  lessonsScreenType === "cabinet"
                    ? "nav-button__name__cabinet"
                    : "nav-button__name"
                }`}
              >
                <span style={{ width: "50px" }}></span>
                {window.innerWidth > 900 && <>Настройки</>}
              </span>
            )}
          </div>
        )}

        {lessonsScreenType === "quest" &&
          activeQuestID !== null &&
          +activeQuestID >= 0 && (
            <LinkButton to={routes.quests} mod="map-nav__back" color="orange">
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.9196 28.2091L9.61008 20.8995C9.06334 20.3528 9.06334 19.4664 9.61008 18.9196L16.9196 11.6101C17.4664 11.0634 18.3528 11.0634 18.8995 11.6101C19.4463 12.1568 19.4463 13.0433 18.8995 13.59L13.9799 18.5096H29C29.7732 18.5096 30.4 19.1364 30.4 19.9096C30.4 20.6828 29.7732 21.3096 29 21.3096H13.9799L18.8995 26.2292C19.4463 26.7759 19.4463 27.6624 18.8995 28.2091C18.3528 28.7558 17.4664 28.7558 16.9196 28.2091Z"
                  fill="white"
                />
              </svg>
            </LinkButton>
          )}

        {children}

        {[
          "infantCabinet",
          "coinShop",
          "scoreTable",
          "quest",
          "game",
          "prizes",
          "cabinet",
          "test",
        ].includes(lessonsScreenType) && (
          <Button
            mod="map-nav__home"
            onClick={() => {
              if (localStorage.getItem("dataAtFirstLoad")) {
                this.props.setPreloader("default");
              }

              redirect();
            }}
            color="orange"
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M30.0008 17.4026L20.4358 10.5359C20.1611 10.3547 19.8315 10.3547 19.5751 10.5359L10.0101 17.4026C9.27757 17.8859 9.58889 19.1142 10.4496 19.1142C10.9074 19.1142 11.292 19.517 11.292 20.0405V27.8737C11.292 28.3772 11.6582 28.8 12.1344 28.8H16.2479C16.6691 28.8 17.0171 28.4174 17.0171 27.9543V23.3832C17.0171 22.4569 17.6946 21.7119 18.537 21.7119H21.5105C22.3529 21.7119 23.0304 22.4569 23.0304 23.3832V27.914C23.0304 28.3772 23.3784 28.7597 23.7996 28.7597H27.9131C28.3709 28.7597 28.7555 28.357 28.7555 27.8335V20.0204C28.7555 19.517 29.1218 19.0941 29.5979 19.0941C30.4037 19.0941 30.715 17.8657 30.0008 17.4026Z"
                fill="white"
              />
            </svg>
          </Button>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = {
  setPreloader,
};

export default withRouter(connect(null, mapDispatchToProps)(MapNav));
